import React from "react";
import Api from "../../Assets/Services/icons-api.png";
import webApplication from "../../Assets/Services/icons-web-development.png";
import firebase from "../../Assets/Services/icons-webapp.png";
import webDesign from "../../Assets/Services/icon-web-design.png";

const cardData = [
  {
    id: 1,
    title: "Web Design And Development",
    image: webDesign,
    desc: "Transform your digital presence with our design and development services. We combine creativity and technical expertise to create visually stunning and highly functional websites.",
  },
  {
    id: 2,
    title: "Web Application Development",
    image: webApplication,
    desc: "Empower your online presence with our web application development expertise. We specialize in crafting user-friendly, custom web solutions that meet your specific requirements.",
  },
  {
    id: 3,
    title: "Web Application With Firebase Development",
    image: firebase,
    desc: "Elevate your web application with Firebase development. Our experts harness Firebase's real-time database, authentication, and cloud services to deliver secure, dynamic, and responsive web solutions",
  },
  {
    id: 4,
    title: "Restful API's Development",
    image: Api,
    desc: "Unlock the power of efficient Restful API development for seamless data integration and application connectivity. Our expertise ensures smooth communication between your digital services",
  },
];

const Services = () => {
  return (
    <div>
      <div className="container">
        <div className="row">
          {cardData.map((card, index) => (
            <div className="col-lg-3" key={index}>
              <div
                className="card shadow-box-2 bg-dark"
                style={{ height: "19rem" }}
              >
                <div className="text-center mt-4">
                  <img
                    src={card.image}
                    className="img-fluid"
                    alt="..."
                    width="48"
                    height="48"
                  />
                  <div className="card-body">
                    <h6 className="card-title">{card.title}</h6>
                    <p className="card-text enhance-text">{card.desc}</p>
                    {/* <a href="#" className="btn btn-primary">
                    Go somewhere
                  </a> */}
                  </div>
                </div>
              </div>{" "}
              <br />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
